<template>
  <lab-task><lab-identifying-solutions-based-on-reactions /></lab-task>
</template>

<script>
import LabIdentifyingSolutionsBasedOnReactions from '../simulations/LabIdentifyingSolutionsBasedOnReactions';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import {defineComponent} from '@vue/composition-api';
import LabTask from './labs/LabTask';
export default defineComponent({
  name: 'IdentifyingSolutionsBasedOnReactionsSIM',
  components: {LabIdentifyingSolutionsBasedOnReactions, LabTask},
  mixins: [DynamicQuestionMixin()],
});
</script>
